// API base: same origin in prod (API + client share one Render service).
const BASE = process.env.REACT_APP_API_URL || '';

// NOTE: this wrapper does NOT auto-stringify. For POST/PATCH you MUST pass:
//   apiFetch('/api/x', { method:'POST',
//     headers:{ 'Content-Type':'application/json' },
//     body: JSON.stringify(payload) })
export async function apiFetch(path, options = {}) {
  const token = localStorage.getItem('hq_token');
  const headers = { ...(options.headers || {}) };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  const res = await fetch(BASE + path, { ...options, headers });
  return res;
}
